Alpine.magic('goToCheckout', (_, {Alpine}) =>{
    return (url = null) => {
        const mainEventId = Alpine.store('cart').mainEvent.id;

        if (!mainEventId) {
            return;
        }

        if (!Alpine.store('customerImages').count && !Alpine.store('cart').total) {
            window.$wireui.notify({
                title: `You need to have images in your album to select this step.`,
                icon: 'warning',
            });

            return;
        }

        if (!Alpine.store('cart').prepaidDone) {
            window.location.href = `/checkout/${mainEventId}/photo-package`;

            return;
        }

        window.location.href = url ?? `/checkout/${mainEventId}/products`;
    }
});
